module.exports = __webpack_public_path__ + "assets/assets/images/icons/delete_icon.88d37381.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/delete_icon.svg
// module id = 530
// module chunks = 0